import {
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import ExcelJS from "exceljs";
import { useEffect, useState } from "react";
import Page from "src/components/Page";
import "jspdf-autotable";
import useSettings from "src/hooks/useSettings";
import Iconify from "src/components/Iconify";

import WithoutPagination from "src/components/mrt-table/WithoutPagination";

import { useQuery } from "react-query";
import { getAllDraftByStatus, masterGetData } from "src/pages/api";
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import { PATH_DASHBOARD } from "src/routes/paths";
import AddDraftOrder from "./add";
import Label from "src/components/Label";
import ApproveDeleteDraft from "./approve-delete-draft";
import OrderDetail from "./order-detail";

export const getStatusColor = status => {
  const error = [
    "Cancelled",
    "Refund",
    "Payment Initiated",
    "Payment Failed",
    "RTO",
  ];
  const warning = ["Partial Delivered", "Pending", "Processing"];
  const info = ["Delivered"];
  if (status === "Tuckshop") return "info";
  if (status) {
    if (error.includes(status)) {
      return "error";
    }
    if (warning.includes(status)) {
      return "primary";
    }
    if (info.includes(status)) {
      return "info";
    }
    return "success";
  }
  return "success";
};

export default function DraftOrder() {
  const { themeStretch } = useSettings();
  const [selectedSchool, setSelectedSchool] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [open, setOpen] = useState(false);
  const [openUpdateStatus, setOpenUpdateStatus] = useState(false);
  const [actionType, setActionType] = useState("");

  const columns = [
    {
      accessorKey: "schoolName",
      header: "School Name",
    },
    // {
    //   accessorKey: "createdDate",
    //   header: "Created Date",
    // },
    {
      accessorKey: "status",
      header: "Status",
      size: 160,
      Cell: () => (
        <Label variant={"ghost"} color={"primary"}>
          Pending
        </Label>
      ),
    },
  ];
  const { data } = useQuery({
    queryKey: ["getData", "schools", 0, 100],
    queryFn: masterGetData,
  });
  const { data: draftOrderList } = useQuery({
    queryKey: ["draftOrder", selectedSchool, 1],
    queryFn: getAllDraftByStatus,
    enabled: !!selectedSchool,
  });

  useEffect(() => {
    setSelectedSchool(data ? data?.data[0]?.id : "");

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
  
  const exportToExcel = async (data, schoolName) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Purchase Orders");
  
    const headers = [
      "SR NO",
      "ISBN",
      "NAME OF THE BOOK",
      "Price",
      "QTY",
      "GROSS AMT",
      "SCHOOL NAME",
      "DISCOUNT TO BOOK BASE",
    ];
  
    const borderStyle = {
      top: { style: "thin", color: { argb: "000000" } },
      left: { style: "thin", color: { argb: "000000" } },
      bottom: { style: "thin", color: { argb: "000000" } },
      right: { style: "thin", color: { argb: "000000" } },
    };
  
    // Add header row
    const headerRow = worksheet.addRow(headers);
    headerRow.height = 30;
    headerRow.eachCell(cell => {
      cell.font = { bold: true, color: { argb: "000000" } };
      cell.alignment = { vertical: "middle", horizontal: "center" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "e0e4e8" },
      };
      cell.border = borderStyle;
    });
  
    let totalQty = 0;
    let totalAmount = 0;
  
    data.forEach((item, index) => {
      const row = worksheet.addRow([
        index + 1,
        "", // ISBN
        item.productName,
        item.price,
        item.quantity,
        item.amount,
        schoolName,
        "0%",
      ]);
  
      totalQty += item.quantity;
      totalAmount += item.amount;
  
      row.eachCell((cell, colNumber) => {
        cell.border = borderStyle;
        cell.alignment = { vertical: "middle", horizontal: "center" };
        if (colNumber === 5) {
          cell.font = { bold: true };
        }
        if (colNumber === 8) {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "000000" },
          };
          cell.font = { color: { argb: "00FF00" }, bold: true }; // Green text
        }
      });
    });
  
    // Add Total row
    const totalRow = worksheet.addRow(["Total", "", "", "", totalQty, totalAmount, "", ""]);
    totalRow.eachCell(cell => {
      cell.font = { bold: true };
      cell.border = borderStyle;
      cell.alignment = { vertical: "middle", horizontal: "center" };
    });
  
    // Auto width
    worksheet.columns.forEach((col, i) => {
      const header = headers[i] || "";
      let maxLength = header.length;
  
      col.eachCell({ includeEmpty: true }, cell => {
        const val = cell.value ? cell.value.toString() : "";
        if (val.length > maxLength) {
          maxLength = val.length;
        }
      });
  
      col.width = maxLength + 5;
    });
  
    // Export to file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
  
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Purchase_Orders_${schoolName}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };
  

  return (
    <>
      {open && (
        <AddDraftOrder
          onClose={() => {
            setOpen(false);
            setSelectedRow(null);
          }}
          row={selectedRow}
        />
      )}
      {openUpdateStatus && (
        <ApproveDeleteDraft
          onClose={() => {
            setOpenUpdateStatus(false);
            setSelectedRow(null);
          }}
          actionType={actionType}
          row={selectedRow}
        />
      )}

      <Page title="General:Darft Order">
        <Container maxWidth={themeStretch ? false : "xl"} id={"report"}>
          <HeaderBreadcrumbs
            heading={`Inventory`}
            links={[
              { name: "Dashboard", href: PATH_DASHBOARD.root },
              {
                name: "Inventory",
              },
              { name: "Draft Order" },
            ]}
          />
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <TextField
                label="School"
                size="small"
                select
                SelectProps={{ native: true }}
                fullWidth
                // sx={{ maxWidth: "250px", width: "100%" }}
                value={selectedSchool}
                InputLabelProps={{ shrink: true }}
                onChange={e => {
                  setSelectedSchool(e.target.value);
                }}
              >
                <option value={""}>Choose a School</option>
                {data &&
                  data?.data?.map((el, index) => (
                    <option value={el.id} key={index}>
                      {el.schoolName}
                    </option>
                  ))}
              </TextField>
            </Grid>
          </Grid>
          <Box mt={4}>
            <WithoutPagination
              data={draftOrderList?.data || []}
              columns={columns}
              loading={false}
              renderRowActions={({ row, table }) => (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <IconButton
                    onClick={() => {
                      setSelectedRow(row.original);
                      setActionType("delete");
                      setOpenUpdateStatus(true);
                    }}
                    title="Delete Draft"
                    color="error"
                  >
                    <Iconify icon={"eva:trash-2-outline"} />
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      setSelectedRow(row.original);
                      setActionType("update");
                      setOpenUpdateStatus(true);
                    }}
                    title="Approve Draft"
                    color="warning"
                  >
                    <Iconify icon={"material-symbols:order-approve-rounded"} />
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      exportToExcel(
                        row.original.orderDetails,
                        row.original.schoolName
                      );
                    }}
                    title="Export Draft"
                    color="warning"
                  >
                    <Iconify icon="vscode-icons:file-type-excel2" />
                  </IconButton>
                </Box>
              )}
              renderTopToolbarCustomActions={({ table }) => (
                <Box
                  sx={{
                    display: "flex",
                    gap: "16px",
                    padding: "8px",
                    flexWrap: "wrap",
                  }}
                >
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      setOpen(true);
                    }}
                  >
                    Add New
                  </Button>
                </Box>
              )}
              renderDetailPanel={({ row }) => (
                <OrderDetail row={row.original} />
              )}
              displayColumnDefOptions={{
                "mrt-row-actions": {
                  size: "100",
                },
              }}
            />
          </Box>
        </Container>
      </Page>
    </>
  );
}
